import {
  Auth
} from 'aws-amplify'
import moment from 'moment'
import {
  Cache
} from 'aws-amplify'

const SET_USER = 'SET_USER'
const SET_LOCAL_USER = 'SET_LOCAL_USER'

const cacheConfig = {
  keyPrefix: 'fdi-amplifymodule-'
};
const FDILocalStorage = Cache.createInstance(cacheConfig);

const state = {
  user: null,
  localUser: null,
  userId: null,
  userVerification: [],
  tempUser: null,
  isUserTourAvailable: false,
  tourDateSecondsToStart: null
}
const getters = {
  user: state => {
    return state.user
  },
  localUser: (state) => {
    //console.log('GETTING LOCAL USER')
    return state.localUser
  },
  // username: state => {
  //   return state.user.username ? state.user.username : ''
  // },
  tempUser: (state) => {
    return state.tempUser
  },
  tempCognitoUser: (state) => state.tempCognitoUser,
  isUserTourAvailable: (state) => state.isUserTourAvailable,
  secondToOpenTour: (state) => state.tourDateSecondsToStart
}
const mutations = {
  OPEN_USER_TOUR(state) {
    state.isUserTourAvailable = true
  },
  CLOSE_USER_TOUR(state) {
    state.isUserTourAvailable = false
  },
  SET_USER: (state, user) => {
    //console.log('SETTING USER', user)
    state.user = user
  },
  SET_LOCAL_USER: (state, user) => {
    //console.log("SETTING LOCAL USER")
    state.localUser = user
  },
  clearUser(state) {
    state.user = null
  },
  setUserId(state, userId) {
    state.userId = userId
  },
  clearUserId(state) {
    state.userId = null
  },
  setUserVerification(state, data) {
    state.userVerification = data
  },
  clearUserVerification(state) {
    state.userVerification = null
  },
  setTempUser(state, tempUser) {
    state.tempUser = tempUser
  },
  updateTempUser(state, attrs) {
    state.tempUser = Object.assign({}, state.tempUser, attrs)
  },
  setTempCognitoUser(state, cogUser) {
    state.tempCognitoUser = cogUser
  },
  SET_TOUR_DATE_START(state, dateInSeconds) {
    state.tourDateSecondsToStart = dateInSeconds
  }
}
const actions = {
  setTempUser({
    commit
  }, tempUser) {
    commit('setTempUser', tempUser)
  },
  updateTempUser({
    commit
  }, attrs) {
    commit('updateTempUser', attrs)
  },
  async setUser({
    commit,
    dispatch
  }, user) {
    return new Promise((resolve) => {
      //console.log('USER IN VUEX', user)
      commit(SET_USER, user)
      resolve()
    })
  },
  async setLocalUser({
    dispatch,
    commit
  }, user) {
    return new Promise((resolve) => {
      let localUser = user ? Object.assign({}, user.attributes) : user
      FDILocalStorage.setItem('cognito-user', JSON.stringify(localUser))
      commit(SET_LOCAL_USER, localUser)
      resolve()
    })
  },
  initialSetLocalUser({
    commit
  }) {
    return new Promise(async (resolve) => {
      //console.log('Initial Setup of Local')
      let localUser = await JSON.parse(FDILocalStorage.getItem('cognito-user', {
        callback: () => null
      }))
      commit(SET_LOCAL_USER, localUser)
      resolve()
    })
  },
  setUserId({
    commit
  }, userId) {
    commit('setUserId', userId)
  },
  setUserVerification({
    commit
  }, userVerification) {
    commit('setUserVerification', userVerification)
  },
  setTempCognitoUser({
    commit
  }, tempCogUser) {
    commit('setTempCognitoUser', tempCogUser)
  },
  clearAmplifyCache() {
    FDILocalStorage.clear()
  },
  setUserTourAvailability({
    commit
  }, user) {
    //console.log('Setting availablity')
    var userTourDate = user.attributes['custom:tourDate']
    var mUserTourDate = moment(userTourDate)
    //console.log(mUserTourDate.format())
    var userTourOpen = mUserTourDate.subtract(2, 'hour')
    userTourOpen = userTourOpen.format('x')
    //console.log(userTourOpen)
    var now = moment().format('x')
    var diff = userTourOpen - now
    //console.log(diff)


    commit('SET_TOUR_DATE_START', diff)
    if (moment().add(2, 'hour').isSameOrAfter(moment(userTourDate))) {
      commit('OPEN_USER_TOUR')
    } else {
      commit('CLOSE_USER_TOUR')
    }
  }
}

const amplifyModule = {
  state,
  mutations,
  actions,
  getters
}

export default amplifyModule;